import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledHelpIconButton = styled(IconButton)`
    &:active {
        background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};
    }

    &,
    &:hover {
        ${SWReactIcons} svg path {
            fill: ${colorsPalettes.blue["400"]};
        }
    }
`;
